package gr.tech.GRAttestation.models.attestation

import kotlinx.serialization.Serializable

@Serializable
data class AttestationDTO(
    val id: Int,
    val storeId: Int,
    val storeName: String,
    val salesData: List<SalesData>,
    val repName: String,
    val reportingMonth: String,
    val dateSigned: String,
    val createdAt: String,
    val updatedAt: String,
    val status: Short,
    val fileName: String,
    val filePath: String,
)